import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=6a61529f&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=6a61529f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a61529f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a61529f')) {
      api.createRecord('6a61529f', component.options)
    } else {
      api.reload('6a61529f', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=6a61529f&scoped=true&", function () {
      api.rerender('6a61529f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27DyyNsjIIS7g/JS/comp/Paginate.vue"
export default component.exports